import { c as _c } from "react/compiler-runtime";
import type { EmblaCarouselType } from 'embla-carousel';
import { Button } from '@/app/components/button';
import { ButtonGroup } from '@/app/components/button-group';
import { IconArrowBack } from '@/app/components/icons/ui-actions/icon-arrow-back';
import { IconArrowForward } from '@/app/components/icons/ui-actions/icon-arrow-forward';
import { Sliders } from '@/app/components/sliders';
import { ThumbItem } from '@/app/cv/components/sections/products/rear-body/sliders/thumbs/thumb-item';
import type { RearBodyItem } from '@/app/cv/components/sections/products/types';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
interface ProductRearBodyThumbSliderProps {
  items: RearBodyItem[];
  currentIndex: number;
  hasMultipleItems: boolean;
  svgSrc?: string;
  prevBtnDisabled?: boolean;
  nextBtnDisabled?: boolean;
  onPrevButtonClick: () => void;
  onNextButtonClick: () => void;
  onThumbClick: (index: number) => void;
  onEmblaInit: (emblaApi: EmblaCarouselType) => void;
}
interface SliderButtonProps {
  direction: 'previous' | 'next';
  disabled?: boolean;
  onClick: () => void;
}
const SliderButton = t0 => {
  const $ = _c(10);
  const {
    direction,
    disabled,
    onClick
  } = t0;
  const t1 = direction === "previous" ? "Previous" : "Next";
  let t2;
  if ($[0] !== direction) {
    t2 = direction === "previous" ? <IconArrowBack /> : <IconArrowForward />;
    $[0] = direction;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `${direction}-button`;
  let t4;
  if ($[2] !== t3) {
    t4 = createDataAttributes({
      test: t3
    });
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== disabled || $[5] !== onClick || $[6] !== t1 || $[7] !== t2 || $[8] !== t4) {
    t5 = <Button aria-label={t1} color="white" variant="secondary" width="auto" shadow="md" iconBefore={t2} disabled={disabled} onClick={onClick} {...t4} />;
    $[4] = disabled;
    $[5] = onClick;
    $[6] = t1;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export const ProductRearBodyThumbSlider = t0 => {
  const $ = _c(40);
  const {
    svgSrc,
    items: t1,
    currentIndex: t2,
    hasMultipleItems: t3,
    prevBtnDisabled: t4,
    nextBtnDisabled: t5,
    onPrevButtonClick,
    onNextButtonClick,
    onThumbClick,
    onEmblaInit
  } = t0;
  let t6;
  if ($[0] !== t1) {
    t6 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const items = t6;
  const currentIndex = t2 === undefined ? 0 : t2;
  const hasMultipleItems = t3 === undefined ? false : t3;
  const prevBtnDisabled = t4 === undefined ? false : t4;
  const nextBtnDisabled = t5 === undefined ? false : t5;
  let t7;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = createDataAttributes({
      test: "thumb-slider"
    });
    $[2] = t7;
  } else {
    t7 = $[2];
  }
  let t8;
  if ($[3] !== hasMultipleItems || $[4] !== nextBtnDisabled || $[5] !== onNextButtonClick || $[6] !== onPrevButtonClick || $[7] !== prevBtnDisabled) {
    t8 = !!hasMultipleItems && <ButtonGroup className="justify-center lg:hidden" aria-label="rear body navigation"><SliderButton direction="previous" disabled={prevBtnDisabled} onClick={onPrevButtonClick} /><SliderButton direction="next" disabled={nextBtnDisabled} onClick={onNextButtonClick} /></ButtonGroup>;
    $[3] = hasMultipleItems;
    $[4] = nextBtnDisabled;
    $[5] = onNextButtonClick;
    $[6] = onPrevButtonClick;
    $[7] = prevBtnDisabled;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = createDataAttributes({
      test: "rear-body-thumb-sliders"
    });
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== hasMultipleItems || $[11] !== onPrevButtonClick || $[12] !== prevBtnDisabled) {
    t10 = !!hasMultipleItems && <SliderButton direction="previous" disabled={prevBtnDisabled} onClick={onPrevButtonClick} />;
    $[10] = hasMultipleItems;
    $[11] = onPrevButtonClick;
    $[12] = prevBtnDisabled;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = createDataAttributes({
      test: "wrapper-container"
    });
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  const t12 = items.length < 4 ? "center" : "start";
  let t13;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      inViewThreshold: 0.99
    };
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== currentIndex || $[17] !== items || $[18] !== onThumbClick || $[19] !== svgSrc) {
    let t15;
    if ($[21] !== currentIndex || $[22] !== onThumbClick || $[23] !== svgSrc) {
      t15 = (item, index) => <ThumbItem key={index} item={item} index={index} isActive={currentIndex === index} svgSrc={svgSrc} onThumbClick={onThumbClick} />;
      $[21] = currentIndex;
      $[22] = onThumbClick;
      $[23] = svgSrc;
      $[24] = t15;
    } else {
      t15 = $[24];
    }
    t14 = items.map(t15);
    $[16] = currentIndex;
    $[17] = items;
    $[18] = onThumbClick;
    $[19] = svgSrc;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[25] !== onEmblaInit || $[26] !== t12 || $[27] !== t14) {
    t15 = <div className="w-full max-w-204 xl:max-w-226" {...t11}><Sliders onEmblaInit={onEmblaInit} align={t12} loop={false} emblaOptions={t13} containerClassName="gap-x-6">{t14}</Sliders></div>;
    $[25] = onEmblaInit;
    $[26] = t12;
    $[27] = t14;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== hasMultipleItems || $[30] !== nextBtnDisabled || $[31] !== onNextButtonClick) {
    t16 = !!hasMultipleItems && <SliderButton direction="next" disabled={nextBtnDisabled} onClick={onNextButtonClick} />;
    $[29] = hasMultipleItems;
    $[30] = nextBtnDisabled;
    $[31] = onNextButtonClick;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t10 || $[34] !== t15 || $[35] !== t16) {
    t17 = <div className="hidden items-center justify-center gap-x-8 lg:flex xl:gap-x-12" role="group" aria-label="rear body thumbnails" {...t9}>{t10}{t15}{t16}</div>;
    $[33] = t10;
    $[34] = t15;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t17 || $[38] !== t8) {
    t18 = <div className="mt-6 sm:mt-10" {...t7}>{t8}{t17}</div>;
    $[37] = t17;
    $[38] = t8;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  return t18;
};